
export default {
    props: {
        image: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        included: {
          type: Boolean,
          required: true
        },
        copy: {
            type: String,
            required: true
        },
        textColor: {
          type: String,
          required: false,
          default: () => '#FFFFFF'
        }
    },
    created() {
    },
}
